module.exports = __webpack_public_path__ + "media/m7.dadf280e.mp4";